<div
  class="container"
  [formGroup]="form"
>
  <mat-radio-group
    [class.hide-checkbox]="prices?.length === 1"
    formControlName="unrestrictedAccess"
  >
    <mat-radio-button
      *ngFor="let price of prices"
      [value]="price.unrestrictedAccess"
      [class.free]="price.free"
      [class.disabled]="price.disabled"
      [class.invalid]="matcher.submitted && form.controls.unrestrictedAccess.hasError('required')"
    >
      <div class="wrapper">
        <div class="title">{{ price.title }}</div>
        <div class="subtitle">{{ price.subtitle }}</div>
        <div class="price-group">
          <span
            class="price"
            [class.text-strikeout]="price.strikeout"
            >{{ price.price }}</span
          >
          <span
            class="discount"
            *ngIf="price.discount"
            >{{ price.discount }}</span
          >
          <span
            class="discount"
            *ngIf="price.free"
            >Free</span
          >
        </div>
      </div>
    </mat-radio-button>
  </mat-radio-group>

  <span
    class="blurb"
    *ngIf="!freeMode"
  >
    Your card will be charged automatically once you submit the request.
  </span>
</div>
